import bbc from '../../Images/logos/logo_bbc.png';
import logo_bbc_white from '../../Images/logos/logo_bbc_white.png';
import bleeding_fingers from '../../Images/logos/logo_bleeding.png';
import bulgari from '../../Images/logos/logo_bulgari.png';
import bulgari_white from '../../Images/logos/logo_bulgari_white.png';
import cnn_plus from '../../Images/logos/logo_cnn.png';
import Discovery from '../../Images/logos/logo_discovery.png';
import Discovery_white from '../../Images/logos/logo_discovery_white.png';
import Disney_plus_logo from '../../Images/logos/logo_disney.png';
import Disney_plus_logo_white from '../../Images/logos/logo_disney_white.png';
import fox from '../../Images/logos/logo_fox.png';
import fox_white from '../../Images/logos/logo_fox_white.png';
import hbo_max from '../../Images/logos/logo_hbo.png';
import hbo_max_white from '../../Images/logos/logo_hbo_white.png';
import prime from '../../Images/logos/logo_prime.png';
import Tribeca_Festival_logo from '../../Images/logos/logo_tribeca.png';
import Tribeca_Festival_logo_white from '../../Images/logos/logo_tribeca_white.png';
import vox from '../../Images/logos/logo_vox.png';
import youtube from '../../Images/logos/logo_youtube.png';
import youtube_white from '../../Images/logos/logo_youtube_white.png';
import ZAG_Logo from '../../Images/logos/logo_zag.png';
import ZAG_Logo_white from '../../Images/logos/logo_zag_white.png';
import logo_masterchef from '../../Images/logos/logo_masterchef.png';
import logo_masterchef_white from '../../Images/logos/logo_masterchef_white.png';

import netflix from '../../Images/logos/logo_netflix.png';
import honda from '../../Images/logos/logo_honda.png';
import hulu from '../../Images/logos/logo_hulu.png';
import peacock from '../../Images/logos/logo_peacock.png';
import pure_fishing from '../../Images/logos/logo_pure_fishing.png';

const BrandsData = {
	'netflix': {img:netflix,img_light:netflix,width:400,height:120},
	'prime': {img:prime,img_light:prime,width:200,height:120},
	'hulu': {img:hulu,img_light:hulu,width:300,height:120},
	'hbo_max': {img:hbo_max,img_light:hbo_max_white,width:540,height:120},
	'disney_plus_logo': {img:Disney_plus_logo,img_light:Disney_plus_logo_white,width:250,height:120},
	'peacock': {img:peacock,img_light:peacock,width:120,height:120},
	'fox': {img:fox,img_light:fox_white,width:200,height:120},
	'cnn_plus': {img:cnn_plus,img_light:cnn_plus,width:300,height:120},
	'bbc': {img:bbc,img_light:logo_bbc_white,width:410,height:120},
	'discovery': {img:Discovery,img_light:Discovery_white,width:500,height:120},
	'tribeca_Festival_logo': {img:Tribeca_Festival_logo,img_light:Tribeca_Festival_logo_white,width:280,height:120},
	'vox': {img:vox,img_light:vox,width:200,height:120},
	'youtube': {img:youtube,img_light:youtube_white,width:300,height:120},
	'bleeding_fingers': {img:bleeding_fingers,img_light:bleeding_fingers,width:120,height:120},
	'bulgari': {img:bulgari,img_light:bulgari_white,width:600,height:120},
	'ZAG_Logo': {img:ZAG_Logo,img_light:ZAG_Logo_white,width:260,height:120},
	'masterchef': {img:logo_masterchef,img_light:logo_masterchef_white,width:120,height:120},
	'honda': {img:honda,img_light:honda,width:120,height:120},
	'pure_fishing': {img:pure_fishing,img_light:pure_fishing,width:120,height:120},
}

export default BrandsData;